import React from 'react';
import Layout from './Layout';
import Holidays from '../Holidays';
import { useNavigate } from 'react-router-dom';
import { Button ,Col,Row} from 'react-bootstrap';
import { ArrowLeftCircle } from "react-bootstrap-icons";
export default function AdminHolidays() {
  const navigate=useNavigate();
  return (
    <Layout heading="Holidays">
    <Row className="mb-3">
      <Col xs={12}>
          <Button className="btn btn-secondary mb-3" onClick={() => navigate(-1)}>
            <ArrowLeftCircle />
          </Button>
      </Col>
    </Row>
        <Holidays/>
    </Layout>
  )
}
